export default "__VITE_ASSET__CUpWf0z2__"